import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { assets } from '../../assets/assets';
import './CampaignWatermarkOverlay.scss';

const CampaignWatermarkOverlay = ({ label, className, variant, logoSrc, labelDurationMs }) => {
    const overlayClassName = ['campaign-watermark-overlay', `campaign-watermark-overlay--${variant}`, className]
        .filter(Boolean)
        .join(' ');
    const [showLabel, setShowLabel] = useState(true);
    const patternTiles = useMemo(
        () => Array.from({ length: 180 }, (_, index) => index),
        []
    );

    useEffect(() => {
        setShowLabel(true);
        const labelTimeoutId = setTimeout(() => {
            setShowLabel(false);
        }, labelDurationMs);

        return () => {
            clearTimeout(labelTimeoutId);
        };
    }, [labelDurationMs]);

    return (
        <div className={overlayClassName} aria-hidden="true">
            <div className="campaign-watermark-overlay__pattern">
                {patternTiles.map((tileIndex) => (
                    <div className="campaign-watermark-overlay__tile" key={`wm-tile-${tileIndex}`}>
                        <img className="campaign-watermark-overlay__logo" src={logoSrc} alt="" draggable="false" />
                    </div>
                ))}
            </div>
            {showLabel && <div className="campaign-watermark-overlay__label">{label}</div>}
        </div>
    );
};

CampaignWatermarkOverlay.propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
    variant: PropTypes.oneOf(['fixed', 'absolute']),
    logoSrc: PropTypes.string,
    labelDurationMs: PropTypes.number,
};

CampaignWatermarkOverlay.defaultProps = {
    label: 'Salesforce Number Required',
    className: '',
    variant: 'absolute',
    logoSrc: assets.icastTopLogo,
    labelDurationMs: 2600,
};

export default CampaignWatermarkOverlay;
